module.exports = __webpack_public_path__ + "static/media/mastercard@2x.87165844.png";